var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultsNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 299,
    viewBox: "0 0 273 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.046 169.47L204.815 102.404C208.026 99.8021 212.771 100.479 215.126 103.874L221.34 112.83C223.734 116.28 222.629 121.044 218.96 123.087L125.783 174.995C124.333 175.803 122.511 175.426 121.5 174.111C120.393 172.672 120.636 170.613 122.046 169.47Z",
    stroke: "#5653D2",
    strokeWidth: 1.78928,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.103 176.475C138.293 176.019 138.078 175.495 137.622 175.305C137.166 175.115 136.642 175.331 136.452 175.787L138.103 176.475ZM103.763 254.197C103.573 254.653 103.788 255.177 104.244 255.367C104.7 255.557 105.224 255.342 105.414 254.886L103.763 254.197ZM136.452 175.787L103.763 254.197L105.414 254.886L138.103 176.475L136.452 175.787Z",
    fill: "#5653D2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.758 176.607L137.758 264.06",
    stroke: "#5653D2",
    strokeWidth: 1.78928,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.567 175.753C138.359 175.305 137.827 175.111 137.379 175.32C136.931 175.528 136.737 176.06 136.945 176.508L138.567 175.753ZM166.191 239.376C166.4 239.824 166.932 240.019 167.38 239.81C167.828 239.602 168.022 239.07 167.813 238.622L166.191 239.376ZM136.945 176.508L166.191 239.376L167.813 238.622L138.567 175.753L136.945 176.508Z",
    fill: "#5653D2"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 109H136.5H28C23.0294 109 19 104.971 19 100V76C19 71.0294 23.0294 67 28 67H245C249.971 67 254 71.0294 254 76V100C254 104.971 249.971 109 245 109H228",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 86,
    r: 8.05046,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 232.343,
    y1: 92,
    x2: 237,
    y2: 96.6571,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.8946,
    y: 80.8946,
    width: 40.2107,
    height: 14.2107,
    rx: 5.06963,
    stroke: "#5653D2",
    strokeWidth: 1.78928,
    strokeLinecap: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.8946,
    y: 80.8946,
    width: 62.2107,
    height: 14.2107,
    rx: 5.06963,
    stroke: "#5653D2",
    strokeWidth: 1.78928,
    strokeLinecap: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter9_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0505 37.5C36.0505 42.2713 32.3984 46.0505 28 46.0505C23.6016 46.0505 19.9495 42.2713 19.9495 37.5C19.9495 32.7287 23.6016 28.9495 28 28.9495C32.3984 28.9495 36.0505 32.7287 36.0505 37.5Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 213.5,
    cy: 160.5,
    r: 12.5505,
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter11_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.637 262.956L179.485 262.548L184.263 270.006L180.193 277.873L171.345 278.281L166.567 270.823L170.637 262.956Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter12_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.637 187.246L54.2765 179.701L63.1304 179.946L67.3449 187.737L62.7055 195.282L53.8515 195.036L49.637 187.246Z",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter13_d_1177_39515)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.9449,
    y: 16.1629,
    width: 30.053,
    height: 30.053,
    transform: "rotate(15 58.9449 16.1629)",
    stroke: "#5653D2",
    strokeWidth: 1.89908,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1177_39515",
    x: 106.193,
    y: 88.5912,
    width: 131.028,
    height: 103.825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85891
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1177_39515",
    x: 89.976,
    y: 163.904,
    width: 61.914,
    height: 107.636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85891
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1177_39515",
    x: 123.145,
    y: 164.381,
    width: 29.225,
    height: 116.677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85891
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1177_39515",
    x: 123.143,
    y: 163.904,
    width: 58.4717,
    height: 92.0939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85891
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1177_39515",
    x: 0.958673,
    y: 51.4907,
    width: 271.083,
    height: 78.0829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1177_39515",
    x: 200.908,
    y: 62.4404,
    width: 52.1835,
    height: 52.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1177_39515",
    x: 214.302,
    y: 76.4907,
    width: 40.7398,
    height: 40.7396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1177_39515",
    x: 19.2822,
    y: 68.6679,
    width: 69.4356,
    height: 43.4356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85891
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1177_39515",
    x: 69.2822,
    y: 68.6679,
    width: 91.4356,
    height: 43.4356,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.38571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.85891
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1177_39515",
    x: 1.90826,
    y: 13.4404,
    width: 52.1835,
    height: 53.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1177_39515",
    x: 182.908,
    y: 132.44,
    width: 61.1835,
    height: 61.1835,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1177_39515",
    x: 148.38,
    y: 247.015,
    width: 54.0698,
    height: 51.8646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1177_39515",
    x: 31.4493,
    y: 164.177,
    width: 54.0834,
    height: 51.6932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1177_39515",
    x: 32.9119,
    y: 0.440368,
    width: 73.3165,
    height: 73.3168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.53211
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54587
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.337255 0 0 0 0 0.32549 0 0 0 0 0.823529 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1177_39515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1177_39515",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultsNotFound);
export default __webpack_public_path__ + "static/media/results-not-found.94c4f049edf22e99025f3ca567241b25.svg";
export { ForwardRef as ReactComponent };